import appConfig from "../config/appConfig";
import { logout, refreshToken, script_appender } from "../helpers/function";
import ls from "localstorage-slim";
import { logoutAndRedirectToLogin } from "../helpers/function";
import { verifyTokenExpire, verifyTokenMinutes } from "middleware/verifyToken";

export default function setupAxios(axios, store) {
  axios.defaults.withCredentials = true;
  axios.interceptors.request.use(
    (config) => {
      const token = ls.get("token");
      config.baseURL = appConfig.apiDomaine;
      config.headers.post["Content-Type"] = "application/json";
      // config.headers.post["X-Content-Type-Options"] = "nosniff";
      // config.headers.post["X-XSS-Protection"] = "1; mode=block";
      if (token && !config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (err) => Promise.reject(err)
  );

  async function logoutUserAndRedirectToLogin(ifCb, elseCb) {
    if (!window.location.href.endsWith("/login")) {
      if (ls.get("userData") == null || ls.get("token") == null || !verifyTokenExpire()) {
        logoutAndRedirectToLogin();
        return;
      }
      // Si le token n'est pas expiré et que la date expiration <= 5min
      if (verifyTokenMinutes()) {
        // Évite les refresh multiples
        if (!ls.get("refreshToken")) {
          ls.set("refreshToken", true);
          try {
            await refreshToken(); // On attend que le refresh soit terminé
          } catch (err) {
            // Si le refresh échoue, on déconnecte le user
            logoutAndRedirectToLogin();
            return;
          }
        }
        return ifCb();
      }
      return ifCb();
    } else {
      return elseCb();
    }
  }
  
  // Interceptor de réponse Axios
  axios.interceptors.response.use(
    async (response) => {

      // Si aucun refresh en cours
      if (!ls.get("refreshToken")) {
        
        // Scripts à réinjecter dans la page (non lié au token)
        script_appender("/assets/js/jquery.tablesorter.min.js");
        script_appender("/assets/js/main.js");

        return await logoutUserAndRedirectToLogin(
          () => response, 
          () => response 
        );
      }

      // Une fois que le token est refreshé, on nettoie la session
      ls.remove("refreshToken");
      return response;
    },
    (error) => {
      // On gère les erreurs ici normalement (ex: 401)
      if (window.location.href !== "/login" && 
        ls.get("userData") !== null &&
        error.response?.status === 401 &&
        error.response?.data?.error.toLowerCase() === "unauthenticated"
      ) {
        ls.remove("userData");
        logout()
      }
      return Promise.reject(error);
    }
  );
}
